import { useCallback, useState } from 'react';
import { isNil } from 'lodash';

export default function useOverlayState(show) {
  const [showOverlay, setShowOverlay] = useState(!!show);

  const toggleShowOverlay = useCallback(
    show => {
      setShowOverlay(isNil(show) ? !showOverlay : !!show);
    },
    [showOverlay]
  );

  return [showOverlay, toggleShowOverlay];
}
